import Tooltip from '@anm/components/Tooltip';
import { flexCenter, media } from '@anm/styles/helpers';
import styled from 'styled-components';

import { PlanFeatureText } from '../Wrapper';

const planFeatureWithTooltipMobile = media.phone`
    font-size: 12px;
    line-height: 1.83;
    padding: 5px 0 5px 30px;
`;

export const Info = styled.div`
  margin: 0 0 0 13px;
  width: 20px;
  height: 20px;
  border: 1px solid rgba(0, 56, 87, 0.2);
  border-radius: 50%;

  &:after {
    content: 'i';
    height: 19px;
    font-family: PT Serif;
    font-size: 15px;
    font-style: italic;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: left;
    color: #bcc6cc;
    ${flexCenter}
  }
`;

export const New = styled.div`
  display: flex;
  margin: 0 0 0 13px;
  width: 41px;
  height: 24px;
  flex-direction: row;
  align-items: flex-start;
  padding: 2px 5px;
  background: #d9f2ff;
  border-radius: 5px;

  &:after {
    content: 'New!';
    font-weight: 800;
    font-size: 12px;
    line-height: 20px;
    color: var(--blue_200);

    ${flexCenter}
  }
`;

export const PricingTooltip = styled(Tooltip)`
  width: 292px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #fff;
  padding: 12px 20px 15px;
`;

export const PlanFeatureWithTooltip = styled.div`
  position: relative;
  ${PlanFeatureText} {
    border-bottom: 1px dotted rgba(41, 42, 43, 0.5);
    padding-bottom: 4px;
    cursor: pointer;
    &:hover {
      border-bottom-color: transparent;
    }
  }
  ${planFeatureWithTooltipMobile};
`;
